import { render, staticRenderFns } from "./InventoryDashboardV2.vue?vue&type=template&id=079e4d1e&"
import script from "./InventoryDashboardV2.vue?vue&type=script&lang=js&"
export * from "./InventoryDashboardV2.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDashboardV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports